var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-body"},[_c('h4',[_vm._v(_vm._s(_vm.message))]),_vm._m(0)])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"/"}},[_vm._v("Voltar para a home")])])
}]

export { render, staticRenderFns }